<template> 
    <v-card>
        <v-container>
            <v-row align="center" justify="space-around" dense>
                <v-col cols="12" sm="6" md="3" align="center" class="pb-0">
                    {{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.temperature') }}
                    <v-alert outlined dense class="mb-1">
                        <v-row dense>
                            <v-col
                                v-for="metric in internalMetrics"
                                :key="metric.title"
                                align="center"
                            >
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            <v-icon :color="metric.bool ? 'red' : 'green'" size="40" >
                                                {{ metric.bool ? metric.iconAlert : metric.iconOk }}
                                            </v-icon>
                                            <div>{{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.inside') }}</div>
                                        </div>
                                    </template>                                 
                                    <span>{{ $vuetify.lang.t(metric.title) }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col
                                v-for="metric in externalMetrics"
                                :key="metric.title"
                                align="center"
                            > 
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <div v-on="on" v-bind="attrs">
                                            <v-icon :color="metric.bool ? 'red' : 'green'" size="40" >
                                                {{ metric.bool ? metric.iconAlert : metric.iconOk }}
                                            </v-icon>
                                            <div>{{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.outside') }}</div>
                                        </div>
                                    </template>                                 
                                    <span>{{ $vuetify.lang.t(metric.title) }}</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-alert>
                </v-col>
                <v-col cols="12" sm="6" md="3" align="center" class="pb-0">
                    {{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.supply') }}                    
                    <v-alert outlined dense class="mb-1">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <div v-on="on" v-bind="attrs">
                                    <v-icon :color="utcInfos.isSupplyExceeds ? 'red' : 'green'" size="40">
                                        {{ utcInfos.isSupplyExceeds ? 'mdi-flash-alert-outline' : 'mdi-flash-outline' }}                                                
                                    </v-icon>
                                    <div>{{ ($vuetify.lang.current == 'fr' && utcInfos.isSupplyExceeds )  ? "Aucune" : "" }} {{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.supply') }} {{ utcInfos.isSupplyExceeds ? ($vuetify.lang.current === 'fr' ? "" : "not OK") : "OK" }}</div>
                                </div>
                            </template>                                 
                            <span>{{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.utcsupplymonitoring') }}</span>
                        </v-tooltip>
                    </v-alert>
                </v-col>
                <v-col cols="12" sm="6" md="3" align="center" class="pb-0">
                    {{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.connection') }}
                    <v-alert outlined dense class="mb-1">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                                
                                <div v-on="on" v-bind="attrs">
                                    <v-icon :color="utcInfos.isConnected ? 'green' : 'red'" size="40">
                                        {{ utcInfos.isConnected ? 'mdi-signal' : 'mdi-signal-off' }}
                                    </v-icon>
                                    <div>{{ utcInfos.isConnected ? $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.connected') : $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.not') + " " + $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.connected') }}</div>
                                </div>
                            </template>                                 
                            <span>{{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.utcconnectionstatus') }}</span>
                        </v-tooltip>
                    </v-alert>
                </v-col>
                <v-col cols="12" sm="6" md="3" align="center" class="pb-0">
                    {{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.operatingtime') }}
                    <v-alert outlined dense class="mb-1">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                                
                                <div v-on="on" v-bind="attrs">
                                    <v-icon color='grey' size="40">
                                        mdi-clock
                                    </v-icon>
                                    <div>{{ operatingTime }}</div>
                                </div>
                            </template>                                 
                            <span>{{ $vuetify.lang.t('$vuetify.utc.environmentalMetricsCard.totaloperatingtimesincefirstuse') }}</span>
                        </v-tooltip>
                    </v-alert>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: "EnvironmentalMetricsCard",
        props: {
            utcInfos: Object,
        },
        computed: {
            internalMetrics() {
                return [
                    { 
                        title: '$vuetify.utc.environmentalMetricsCard.utcinternaltemperature',
                        bool: this.utcInfos.isTempExceeds,
                        iconOk: 'mdi-thermometer',
                        iconAlert: 'mdi-thermometer-alert',
                    },
                    
                ]
            },
            externalMetrics() {
                return [
                    { 
                        title: '$vuetify.utc.environmentalMetricsCard.externaltemperatureonthefrontofutcscenedirection',
                        bool: this.utcInfos.isTempExtExceeds,
                        iconOk: 'mdi-thermometer',
                        iconAlert: 'mdi-thermometer-alert',
                    },
                ]
            },
            operatingTime() {
                return this.secondsToTime(this.utcInfos.operatingTime)
            }
        },
        methods: {
            secondsToTime(timeInSeconds) {
                let hours = Math.floor(timeInSeconds / 3600).toString().padStart(2, '0');
                let minutes = Math.floor((timeInSeconds % 3600) / 60).toString().padStart(2, '0');
                let seconds = (timeInSeconds % 60).toString().padStart(2, '0');
                return hours + "h " + minutes + "m " + seconds + "s";
            }
        }
    }
</script>